import { Header } from "@/components/Header";
import { useAuth } from "@/contexts/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import { LogOut, Heart, Mail, ChevronRight, Settings, Info } from "lucide-react";

export default function Profile() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (user === null) return null;

  if (user === false) {
    return (
      <>
        <Header />
        <div className="px-6 py-20 text-center">
          <div className="w-20 h-20 rounded-full bg-gradient-to-br from-brand to-orange-500 mx-auto grid place-items-center text-3xl font-bold shadow-xl shadow-brand/40 mb-5">
            M
          </div>
          <h2 className="font-heading text-2xl font-bold">Welcome to DeshFlix</h2>
          <p className="text-white/55 text-sm mt-2 mb-6">Sign in to save videos and personalize your feed.</p>
          <div className="flex flex-col gap-3 max-w-xs mx-auto">
            <Link
              to="/login"
              data-testid="profile-login-btn"
              className="bg-brand text-white font-semibold py-3 rounded-full shadow-[0_0_20px_rgba(230,59,46,0.45)] hover:bg-brand-hover transition"
            >
              Log in
            </Link>
            <Link
              to="/register"
              data-testid="profile-register-btn"
              className="bg-bg-surface border border-white/10 text-white font-semibold py-3 rounded-full hover:bg-white/5 transition"
            >
              Create account
            </Link>
          </div>
        </div>
      </>
    );
  }

  const initial = user.name?.charAt(0).toUpperCase() || "U";

  return (
    <>
      <Header />
      <div className="px-4 pt-2">
        <div className="flex items-center gap-4 bg-bg-surface border border-white/10 rounded-2xl p-4">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-brand to-orange-500 grid place-items-center text-2xl font-bold shadow-lg shadow-brand/30">
            {initial}
          </div>
          <div className="min-w-0">
            <p className="font-heading text-xl font-semibold truncate">{user.name}</p>
            <p className="text-white/55 text-sm flex items-center gap-1 truncate">
              <Mail size={13} /> {user.email}
            </p>
          </div>
        </div>

        <div className="mt-6 space-y-2">
          <Row icon={Heart} label="Saved videos" to="/saved" testId="profile-saved" />
          <Row icon={Settings} label="Preferences" testId="profile-prefs" />
          <Row icon={Info} label="About DeshFlix" testId="profile-about" />
        </div>

        <button
          onClick={async () => { await logout(); navigate("/"); }}
          data-testid="logout-btn"
          className="w-full mt-8 bg-bg-surface border border-white/10 text-brand font-semibold py-3 rounded-2xl hover:bg-white/5 transition inline-flex items-center justify-center gap-2"
        >
          <LogOut size={18} /> Log out
        </button>

        <p className="text-white/30 text-xs text-center mt-8">DeshFlix • Made for Bangladesh</p>
      </div>
    </>
  );
}

function Row({ icon: Icon, label, to, testId }) {
  const inner = (
    <div className="flex items-center justify-between bg-bg-surface border border-white/10 rounded-2xl px-4 py-3.5 hover:bg-white/5 transition" data-testid={testId}>
      <span className="inline-flex items-center gap-3 text-white/90">
        <Icon size={18} className="text-brand" /> {label}
      </span>
      <ChevronRight size={16} className="text-white/40" />
    </div>
  );
  return to ? <Link to={to}>{inner}</Link> : <button type="button" className="w-full text-left">{inner}</button>;
}
